/**
 * O resultado de mandar um documento para assinatura: quem recebeu o link, e quem ficou de fora e
 * por quê (sem CPF, sem contato, já tinha recebido). A empresa precisa do segundo grupo para
 * completar o cadastro — por isso ele aparece mesmo quando o envio deu certo para os outros.
 */

import React from 'react';
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

import type { ResultadoDoEnvio } from '../../services/envioAoFuncionarioService';

export interface ResultadoDoEnvioDialogProps {
  titulo: string;
  resultado: ResultadoDoEnvio | null;
  onClose: () => void;
}

export const ResultadoDoEnvioDialog: React.FC<ResultadoDoEnvioDialogProps> = ({ titulo, resultado, onClose }) => {
  const navigate = useNavigate();
  if (!resultado) return null;
  const { enviados, naoEnviados } = resultado;

  return (
    <Dialog open onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{titulo}</DialogTitle>
      <DialogContent>
        {enviados.length > 0 ? (
          <Alert severity="success" sx={{ mb: 2 }}>
            Link de assinatura enviado para {enviados.length === 1 ? enviados[0]?.funcionario : `${enviados.length} funcionários`}.
          </Alert>
        ) : (
          <Alert severity="warning" sx={{ mb: 2 }}>
            Ninguém recebeu o link.
          </Alert>
        )}
        {naoEnviados.length > 0 && (
          <>
            <Typography variant="subtitle2">Não enviado</Typography>
            <List dense>
              {naoEnviados.map((n) => (
                <ListItem key={n.funcionario} disableGutters>
                  <ListItemText primary={n.funcionario} secondary={n.motivo} />
                </ListItem>
              ))}
            </List>
          </>
        )}
      </DialogContent>
      <DialogActions>
        {enviados.length > 0 && <Button onClick={() => navigate('/assinaturas')}>Acompanhar em Assinaturas</Button>}
        <Button variant="contained" onClick={onClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ResultadoDoEnvioDialog;
